import React from "react";
import WelcomeImage from '../assets/welcome.png';
import { ROLE } from "../utils/constant";

const WelcomeWrapper = ({ logInType }) => {
  return (
    <div className="h-full">
      <img className="w-full" style={{ height: '53vh' }} src={WelcomeImage} alt="welcome" />
      <div className="flex flex-col justify-center items-center mt-36">
        <span className="text-3xl font-bold p-2 text-gray-600">
          {logInType === ROLE.ORGANIZATION ? 'Welcome Land Rover' : 'Welcome'}
        </span>
        <span className="p-2 text-gray-600">
          {logInType === ROLE.ORGANIZATION ? 'Fetching Devices' : 'Fetching Wallet'}
        </span>
      </div>
    </div>
  );
};

export default WelcomeWrapper;
